import { render, staticRenderFns } from "./normalOrder.vue?vue&type=template&id=2e8da7d4&scoped=true"
import script from "./normalOrder.vue?vue&type=script&lang=js"
export * from "./normalOrder.vue?vue&type=script&lang=js"
import style0 from "./normalOrder.vue?vue&type=style&index=0&id=2e8da7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8da7d4",
  null
  
)

export default component.exports